function showWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.add("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

showWhenVisible(".section-product-description");

function hideWhenVisible(selector) {
  const elements = document.querySelectorAll(selector);
  const sticky = document.querySelector(".sticky_add_to_cart");
  if (!elements.length) {
    console.log("No elements found for:", selector);
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        sticky.classList.remove("visible");
      }
    });
  });

  elements.forEach(el => observer.observe(el));
}

hideWhenVisible(".product-title");

const params = new URLSearchParams(window.location.search);
const customerPosted = params.get('customer_posted');

if (customerPosted === 'true') {
  const getPopup = document.querySelector(".popup-minimal");
  getPopup.style.display = "none";
  console.log('Customer posted is true');
}

function moveAppBlock() {
  const appBlock = document.querySelector('.monk-app-block');

  if (!appBlock) return;

  if (window.innerWidth >= 768) {

    const desktopContainer = document.querySelectorAll('#MainContent .product-media-container')[0]?.appendChild(appBlock);

    if (desktopContainer) {
      desktopContainer.appendChild(appBlock);
    }
  } else {
    const mobileContainer = document.querySelectorAll('#MainContent .product-content-container')[0]?.appendChild(appBlock);

    if (mobileContainer) {
      mobileContainer.appendChild(appBlock);
    }
  }
}

document.addEventListener('DOMContentLoaded', moveAppBlock);
window.addEventListener('resize', moveAppBlock);